import React from 'react';
import OwlCarousel from 'react-owl-carousel3';
import ProductBox from './ProductBox';
//import { Link } from 'react-router-dom';
import "owl.carousel/dist/assets/owl.carousel.min.css";
import "owl.carousel/dist/assets/owl.theme.default.min.css";
import DataSliderBox from "../../common/data/DataSliderBox";

function OwlCarouselHome() {
	const options={
		responsive: {
			0:{
				items:3,
			},
			600:{
				items:4,
			},
			1000: {
			  items: 6,
			},
			1200: {
			  items: 8,
			},
		  },
		  loop:true,
		  nav: true,
		  lazyLoad: true,
		  autoplay: true,
		  dots: false,
		  autoplaySpeed: 1000,
		  autoplayTimeout: 2000,
		  autoplayHoverPause: true,		 
		  navText: ["<i class='fa fa-angle-right' style='font-size:26px;color:navy'></i>", "<i class='fa fa-angle-left' style='font-size:26px;color:navy'></i>"]
	}
    return (
		<OwlCarousel nav loop {...options} className="owl-carousel-category owl-theme">
			{DataSliderBox.map((item, index) => (
				 <div className="item" key={item.id}>					
					<ProductBox
						boxClass='osahan-category-item'
						title={item.title}
						counting={item.alt}
						image={item.src}
						imageClass='img-fluid'
						imageAlt={item.alt}
						linkUrl={item.link}
					/>
				 </div>					
			))}					
		</OwlCarousel>							 
	);
}
export default OwlCarouselHome;